import { render } from "./OurCompanyView.vue?vue&type=template&id=9da719da&scoped=true&ts=true"
import script from "./OurCompanyView.vue?vue&type=script&lang=ts"
export * from "./OurCompanyView.vue?vue&type=script&lang=ts"

import "./OurCompanyView.vue?vue&type=style&index=0&id=9da719da&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da719da"]])

export default __exports__